import * as dto from '@epicuro-next/data/baskets-dto';
import {
  BasketRowsGroup,
  BasketRowsGroupType,
} from 'graphql-api/baskets-api-interfaces';

import {
  getNestedObjects,
  GetRowsFn,
  GroupingFn,
  groupItemsByCategory,
  Mappings,
} from '../mappings';

/**
 * Second level grouping by category.
 */
export function groupByCategory(
  items: dto.Item[],
  maps: Mappings,
  groupFn?: GroupingFn,
  getRowsFn?: GetRowsFn,
): BasketRowsGroup[] {
  const categoryItemIdsMap = groupItemsByCategory(items, maps);

  return Object.keys(categoryItemIdsMap).map((category) => {
    const categoryItems = categoryItemIdsMap[category].map(
      (itemId) => maps.items[itemId],
    );
    const nested = getNestedObjects(categoryItems, maps, groupFn, getRowsFn);

    return {
      id: category,
      type: BasketRowsGroupType.Category,
      title: category,
      ...nested,
    };
  });
}
